import { Model } from '../parents/model';

export class CustomerModel extends Model {
  static ATTR_ID = 'id';
  static ATTR_FIRST_NAME = 'first_name';
  static ATTR_LAST_NAME = 'last_name';
  static ATTR_EMAIL = 'email';
  static ATTR_ALLOWED_STOCK = 'allowed_order_shipment_stock_ids';

  get firstName() {
    return this.attributes[CustomerModel.ATTR_FIRST_NAME];
  }
  get lastName() {
    return this.attributes[CustomerModel.ATTR_LAST_NAME];
  }
  get email() {
    return this.attributes[CustomerModel.ATTR_EMAIL];
  }
  get allowedStockIds() {
    return this.attributes.user[CustomerModel.ATTR_ALLOWED_STOCK];
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }
  get firstAllowedStock() {
    if (this.allowedStockIds && this.allowedStockIds.length) {
      return this.allowedStockIds[0];
    }
    return null;
  }

}
